import React, { useCallback, useEffect, useState } from "react";
import {getData, postData} from '../middleware/apiMiddleware';
import s from './ListeningPartb.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';



const MyTextarea = ({enabledJsonCheck = false, title, setter, getter}) => {
	
	const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
	
	return (<>
		<div style={{display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontWeight:"bold", fontSize:"32px"}}>{title}</div>			
			{(enabledJsonCheck && !isJson(getter)) && (<div className={s.fadeInOut} style={{fontWeight:"bold", fontSize:"26px", color:"red"}}>invalid JSON!</div>)}
		</div>
	
		<textarea style={{border:"1px solid #22222222", width:"100%",
			overflow: 'auto',
			whiteSpace: 'pre-wrap',
			wordWrap: 'break-word'}} value={getter} className={s.textAreaAuto} 
			rows={50} wrap='off' onChange={(e) => {
			setter(e.target.value);
		}}/>
	</>)
}

export default function ListeningPartb(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	
	const [detailJson, setDetailJson] = useState("");
	
	
	const updateDetailJson = async () => {
		let obj = { itemId, detailJson }
		await postData("listeningPartbApi/updateDetailJson", obj, navigate); 
	}
	
	
	const fetchData = async () => {
		getData('listeningPartbApi/data?itemId=' + itemId, navigate)
		.then(res => {
				if(res.data) {
					setDetailJson(res.data['data']);
				}
			}
		);
	}
	
	const isJson = (str) => {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	};
	
	useEffect(() => {
		fetchData();
	}, []);
	
	return (<div style={{textAlign:"left", marginLeft:"20px"}}>
		<div>JSON formatter</div>
		<a href="http://json.parser.online.fr/" target="_blank">http://json.parser.online.fr/</a>

		<div style={{background:"#ebc87c", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea title={"Detail"} setter={setDetailJson} getter={detailJson} />	
			
			<div style={{display:"flex", gap:"10px"}}>
				<GreenButton clickedAction={updateDetailJson} bText={"Update"} />
			</div>
		</div>
		
		
	</div>);
	
}

